export default __webpack_public_path__ + "5619bb74eb75c11fe4e8441fcc8ea4fa.svg";